import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        // 求职登记
        path: '/qiuz',
        name: "qiuz",
        component: () => import(/* webpackChunkName: "about" */ '../components/Quiz.vue'),
      },
      {
        // 热招职位
        path: '/hotwork',
        name: "hotwork",
        component: () => import(/* webpackChunkName: "about" */ '../components/Hotwork.vue'),
        // children: [
        //   {
        //     // 职位详情
        //     path: '/hotwork/workdetail',
        //     name: "workdetail",
        //     component: () => import(/* webpackChunkName: "about" */ '../components/WorkDetail.vue'),
        //   },
        // ]
      },
      {
        // 职位详情
        path: '/hotwork/workdetail',
        name: "workdetail",
        component: () => import(/* webpackChunkName: "about" */ '../components/WorkDetail.vue'),
      },
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
